import { quarterOrder } from "@payangel/shared";
export { normalizeQuarter } from "@payangel/shared";
export function label(value: string | null | undefined) {
  if (!value) return "—";
  return value
    .replaceAll("_", " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function compareQuarters(a: string, b: string) {
  return quarterOrder(a) - quarterOrder(b) || a.localeCompare(b);
}

export function longestDependencyChain(
  items: { id: number; dependencyIds?: number[] }[],
) {
  const byId = new Map(items.map((item) => [item.id, item]));
  const memo = new Map<number, number[]>();
  const visiting = new Set<number>();
  const visit = (id: number): number[] => {
    if (visiting.has(id)) throw new Error("Dependency cycle");
    if (memo.has(id)) return memo.get(id)!;
    visiting.add(id);
    let prefix: number[] = [];
    for (const upstream of byId.get(id)?.dependencyIds ?? []) {
      if (!byId.has(upstream)) continue;
      const path = visit(upstream);
      if (path.length > prefix.length) prefix = path;
    }
    visiting.delete(id);
    const path = [...prefix, id];
    memo.set(id, path);
    return path;
  };
  try {
    return items.reduce<number[]>((best, item) => {
      const path = visit(item.id);
      return path.length > best.length ? path : best;
    }, []);
  } catch {
    return [];
  }
}

export function formatDate(value: string | Date | null | undefined) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    dateStyle: "medium",
    timeStyle: value.toString().includes("T") ? "short" : undefined,
  }).format(new Date(value));
}

export function downloadCsv(
  filename: string,
  rows: Array<Record<string, unknown>>,
) {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]!);
  const csv = [
    headers,
    ...rows.map((row) => headers.map((header) => row[header])),
  ]
    .map((row) => row.map(csvCell).join(","))
    .join("\n");
  const link = document.createElement("a");
  link.href = URL.createObjectURL(
    new Blob([csv], { type: "text/csv;charset=utf-8" }),
  );
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

function csvCell(value: unknown) {
  const text = value == null ? "" : String(value);
  return `"${text.replaceAll('"', '""')}"`;
}
